import { styled, css } from 'styled-components'
import { ReactComponent as CheckSvg } from '../../../../icons/assets/approve.svg'
import { ReactComponent as InfoSvg } from '../../../../icons/assets/Info.svg'

export const Description = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.secondaryDark};
`

const iconProps = css`
  width: 100%;
  height: 100%;
`

export const IconContainer = styled.div`
  width: 12px;
  height: 12px;
  max-width: 12px;
  max-height: 12px;
  margin-right: 6px;
`

export const InfoIcon = styled(InfoSvg)`
  ${iconProps};
`

export const CheckIcon = styled(CheckSvg)`
  ${iconProps};
`
